import env from '../helpers/env';

// @todo can we test for this instead?

const hasAudioOutputLevelStatCapability = () => ['Chrome', 'Samsung', 'Opera', 'Safari', 'iOS_WebView', 'Android_WebView'].indexOf(env.name) > -1;

export default hasAudioOutputLevelStatCapability;
